import { RegisterFeature } from "@eavfw/apps";
import { createTheme } from "@fluentui/react";
import { Chivo } from "@next/font/google"
import { Theme, BrandVariants, createLightTheme, createDarkTheme } from "@fluentui/react-components";
import { createV9Theme } from "@fluentui/react-migration-v8-v9";

export const chivo = Chivo({
    variable: '--chivo',
    subsets: ["latin"]
});
console.log("VARIABLS", chivo);
/*
 * Primary: #154068
 * Text : #060F1A
 * BG: #fff
 * */
const defaultTheme = createTheme({
    palette: {
        themePrimary: '#154068',
        themeLighterAlt: '#f1f5f9',
        themeLighter: '#c9d9e7',
        themeLight: '#9fbad2',
        themeTertiary: '#567fa5',
        themeSecondary: '#24517b',
        themeDarkAlt: '#133a5e',
        themeDark: '#10314f',
        themeDarker: '#0c243b',
        neutralLighterAlt: '#f8f8f8',
        neutralLighter: '#f4f4f4',
        neutralLight: '#eaeaea',
        neutralQuaternaryAlt: '#dadada',
        neutralQuaternary: '#d0d0d0',
        neutralTertiaryAlt: '#c8c8c8',
        neutralTertiary: '#8397b1',
        neutralSecondary: '#637b98',
        neutralPrimaryAlt: '#48607e',
        neutralPrimary: '#060f1a',
        neutralDark: '#1e334c',
        black: '#102033',
        white: '#ffffff',
    },
    defaultFontStyle: {
        fontFamily: 'var(--chivo), Monaco, Consolas'
    }
});

/*
 * Primary: #DDCBA5
 * Text: #fff
 * BG: #154068
 * */
const topbar = createTheme({
    palette: {
        themePrimary: '#ddcba5',
        themeLighterAlt: '#090807',
        themeLighter: '#23211b',
        themeLight: '#433d32',
        themeTertiary: '#857b64',
        themeSecondary: '#c3b492',
        themeDarkAlt: '#e1d1af',
        themeDark: '#e6d8ba',
        themeDarker: '#ece2cb',
        neutralLighterAlt: '#1a466f',
        neutralLighter: '#1f4b75',
        neutralLight: '#28557e',
        neutralQuaternaryAlt: '#2e5b84',
        neutralQuaternary: '#336089',
        neutralTertiaryAlt: '#4b769d',
        neutralTertiary: '#c8c8c8',
        neutralSecondary: '#d0d0d0',
        neutralPrimaryAlt: '#dadada',
        neutralPrimary: '#ffffff',
        neutralDark: '#f4f4f4',

        black: '#f8f8f8',
        white: '#154068',
    },
    defaultFontStyle: {
        fontFamily:'var(--chivo), Monaco, Consolas'
    }
});
 
//RegisterFeature("hafniatheme", hafniatheme);
RegisterFeature("defaultTheme", defaultTheme);
RegisterFeature("topBarTheme", topbar);

 
let v9T = createV9Theme(defaultTheme);


RegisterFeature("defaultV2Theme", v9T);
RegisterFeature("topBarV2Theme", createV9Theme(topbar));